<template>
  <div/>
</template>

<script>
  import lib from '@/lib'
  import router from '@/router'

  export default {
    props: ['DataLayer'],

    created: function() {
      this.$i18n.locale ='es'
      router.push({ path: this.$route.path.replace('/es','') })
    },

    mounted: function() {
      if ( this.DataLayer!=false ) {
        lib.gaDataLayer({'event': 'optimize.Spanish', 'locale': this.$i18n.locale})
      }
    }
  }
</script>
